import Head from "next/head";
import pageIndexRedirection from "../components/locale";
import "swiper/css";
export default function Accueil() {
  const ptitle = `Sunulife: Our African Journey. From Senegal to the World.`;
  const pdescr = `Sunulife: Amplifying the vibrant history and rich culture of Senegal and The Gambia, shared worldwide. At Sunulife, we celebrate the vibrant tapestry of African and diaspora culture, where heritage fuels ambition. Dive into Society for thought-provoking articles on identity and history, sway to Music with Afrobeat and mbalax rhythms, capture Moments of cultural pride, explore Chronicles of migration and legacy, and gain Insights into traditions like Senegalese griots. Inspired by the resilience of the diaspora, we honor the past while soaring toward the future. Join us to connect, learn, and rise.`;
  const pcanon = `https://sunulife.com/`;
  return (<>
    <div className="raqtaq" onLoad={pageIndexRedirection()}>
      <Head>
        <link rel="canonical" href={pcanon} />
        <meta name="description" content={pdescr} />
        <title>{ptitle}</title>
      </Head>
      <h1 style={{display: `none`}}>{ptitle}</h1>
    </div>
  </>)
}